<template>
  <div>
    <cell-group title="项目列表">
      <cell v-for="(item, index) in itemSubList" use-lable-slot :key="index"
      :to="{name:'sportsDetail',params:{'sports_id':item.sports_id,'item_sub_id':item.id}}"
      >
        <template slot="title">
          <van-image :src="item.icon"></van-image>
          <div style="margin:5px 0;"> {{item.title}}</div>
        </template>
        <template slot="label">
          <div style="display:flex;align-items: center;justify-content:space-between;">
            <tag :color="item.state==1?'#15BBEA':''">{{item.state_title}}</tag>
            {{item.start_time_show}} - {{item.end_time_show}}
          </div>
        </template>
      </cell>
    </cell-group>
  </div>
</template>

<script>
import { Cell, CellGroup, Image, Tag } from "vant";
export default {
  name: "ItemList",
  components: {
    Cell,
    CellGroup,
    VanImage: Image,
    Tag,
  },
  props: {
    itemSubList: Array,
  },
};
</script>

<style lang="" scoped>
</style>  